import { DataService } from '../../shared/dataservice.service';
import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { SalesOrder, UiSoOrder, UiSummarySO, SubSalesOrder, FunctionStatus, SOStatus, SSOStatus, monthFilter, MarketingEngineer, userFilterOption, UiWaitReadySO, CommentsPR, PmTechnicalIP, Equipment } from '../../shared/misc-classes';
import { GenService } from '../../shared/gen-ser.service';
import * as XLSX from 'xlsx';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { KPIChartService } from '../../shared/kpi-charts-service';
import * as Highcharts from 'highcharts';


@Component({
  selector: 'app-kpis',
  templateUrl: './kpis.component.html',
  styleUrls: ['./kpis.component.css']
})
export class KpisComponent implements OnInit {

  // constructor(private _dataService2: DataService) { }

  // ngOnInit() {
  //   this._dataService2.currPageName = 'KPIs';
  // } 
      @Input() pmTechSSO: PmTechnicalIP;
      soObj: SalesOrder;
      _soObjList2: Array<SalesOrder>;
    
      // @ViewChild('userImpForm') userImpFrm;
    
      _saleOrderArray2: Array<UiWaitReadySO> = [];
    
      filteredSaleOrderArray2: Array<UiWaitReadySO> = [];
      filteredSOCount2:number = 0;
      filteredSOCount3:number = 0;
      filteredSOCount4:number = 0;
      filteredSOCount5:number = 0;
      filteredSOCount6:number = 0;
      filteredSSOCount2:number = 0;    
      filteredSSOCount3:number = 0;    
      filteredSSOCount4:number = 0;    
      filteredSSOCount5:number = 0;    
      filteredSSOCount5a:number = 0;    
      filteredSSOCount6:number = 0;    
      filteredSSOCount6a:number = 0;    
      isDataViewUpdated2:boolean = false;
      
   
    
      isLoading2: boolean = false;
    
    
      isRevMonthFilterSelected2:boolean = false;
      isInvMonthFilterSelected2:boolean = false;
      isManfMonthFilterSelected2:boolean = false;
     
      revMonthFilter2:monthFilter;
      InvMonthFilter2:monthFilter;
      manfMonthFilter2:monthFilter;
     
      isRevMonthFilterSelected3:boolean = false;
      isInvMonthFilterSelected3:boolean = false;
      isManfMonthFilterSelected3:boolean = false;
     
      revMonthFilter3:monthFilter;
      InvMonthFilter3:monthFilter;
      manfMonthFilter3:monthFilter;

      isRevMonthFilterSelected4:boolean = false;
      isInvMonthFilterSelected4:boolean = false;
      isManfMonthFilterSelected4:boolean = false;
     
      revMonthFilter4:monthFilter;
      InvMonthFilter4:monthFilter;
      manfMonthFilter4:monthFilter;

      isRevMonthFilterSelected5:boolean = false;
      isInvMonthFilterSelected5:boolean = false;
      isManfMonthFilterSelected5:boolean = false;
     
      revMonthFilter5:monthFilter;
      InvMonthFilter5:monthFilter;
      manfMonthFilter5:monthFilter;

      isRevMonthFilterSelected6:boolean = false;
      isInvMonthFilterSelected6:boolean = false;
      isManfMonthFilterSelected6:boolean = false;
     
      revMonthFilter6:monthFilter;
      InvMonthFilter6:monthFilter;
      manfMonthFilter6:monthFilter;
  
      _panelsManf1: number = 0;
      _costManf1: number = 0;
      _panelsManf2: number = 0;
      _costManf2: number = 0;
      _panelsManf3: number = 0;
      _costManf3: number = 0;
      _panelsManf4: number = 0;
      _costManf4: number = 0;


      _panelsTesting1: number = 0;
      _costTesting1: number = 0;
      _panelsTesting2: number = 0;
      _costTesting2: number = 0;
      _panelsTesting3: number = 0;
      _costTesting3: number = 0;
      _panelsTesting4: number = 0;
      _costTesting4: number = 0;


      _panelsFAT1: number = 0;
      _costFAT1: number = 0;
      _panelsFAT2: number = 0;
      _costFAT2: number = 0;
      _panelsFAT3: number = 0;
      _costFAT3: number = 0;
      _panelsFAT4: number = 0;
      _costFAT4: number = 0;


      _panelsGreenSticker1: number = 0;
      _costGreenSticker1: number = 0;
      _panelsGreenSticker2: number = 0;
      _costGreenSticker2: number = 0;
      _panelsGreenSticker3: number = 0;
      _costGreenSticker3: number = 0;
      _panelsGreenSticker4: number = 0;
      _costGreenSticker4: number = 0;


      _panelsDispatch1: number = 0;
      _costDispatch1: number = 0;
      _panelsDispatch2: number = 0;
      _costDispatch2: number = 0;
      _panelsDispatch3: number = 0;
      _costDispatch3: number = 0;
      _panelsDispatch4: number = 0;
      _costDispatch4: number = 0;
      
      CT1: number = 0;
      CT2: number = 0;
      CT3: number = 0;
      CT4: number = 0;

      BrkrMch1: number = 0;
      BrkrMch2: number = 0;
      BrkrMch3: number = 0;
      BrkrMch4: number = 0;
      
      CTreq1: number = 0;
      CTreq2: number = 0;
      CTreq3: number = 0;
      CTreq4: number = 0;

      MBreq1: number = 0;
      MBreq2: number = 0;
      MBreq3: number = 0;
      MBreq4: number = 0;

      CTact1: number = 0;
      CTact2: number = 0;
      CTact3: number = 0;
      CTact4: number = 0;

      MBact1: number = 0;
      MBact2: number = 0;
      MBact3: number = 0;
      MBact4: number = 0;

      highcharts = Highcharts;

      data3: any;
      kpiChartOptions3: Highcharts.Options;
     
      data4: any;
      kpiChartOptions4: Highcharts.Options;
      
      data5: any;
      data5a: any;
      kpiChartOptions5: Highcharts.Options;
      kpiChartOptions5a: Highcharts.Options;
      
      data6: any;
      data6a: any;
      kpiChartOptions6: Highcharts.Options;
      kpiChartOptions6a: Highcharts.Options;
      
      constructor(public _dataService2: DataService, private _genService: GenService, public dialog: MatDialog,
        private _kpiCharServ : KPIChartService) { }
    
      ngOnInit() {
          this._dataService2.currPageName = 'TPT + KPIs';
        try{
          this.loadSettingsFromCookies();
        }catch(e){
          console.log(e);
        }
        
    
        this.loadData();
      }
      saveSettingsToCookies(){
        this._dataService2.setCookie('s-revmonth-sel2', this.isRevMonthFilterSelected2 ? "1":"0");
        if(this.isRevMonthFilterSelected2){
          this._dataService2.setCookie('s-revmonth-val2', this.revMonthFilter2.getCookieStr());
        }
        this._dataService2.setCookie('s-invoicingmonth-sel2', this.isInvMonthFilterSelected2 ? "1":"0");
        if(this.isInvMonthFilterSelected2){
          this._dataService2.setCookie('s-invoicingmonth-val2', this.InvMonthFilter2.getCookieStr());
        }
        this._dataService2.setCookie('s-manfmonth-sel2', this.isManfMonthFilterSelected2 ? "1":"0");
        if(this.isManfMonthFilterSelected2){
          this._dataService2.setCookie('s-manfmonth-val2', this.manfMonthFilter2.getCookieStr());
        }

        this._dataService2.setCookie('s-revmonth-sel3', this.isRevMonthFilterSelected3 ? "1":"0");
        if(this.isRevMonthFilterSelected3){
          this._dataService2.setCookie('s-revmonth-val3', this.revMonthFilter3.getCookieStr());
        }
        this._dataService2.setCookie('s-invoicingmonth-sel3', this.isInvMonthFilterSelected3 ? "1":"0");
        if(this.isInvMonthFilterSelected3){
          this._dataService2.setCookie('s-invoicingmonth-val3', this.InvMonthFilter3.getCookieStr());
        }
        this._dataService2.setCookie('s-manfmonth-sel3', this.isManfMonthFilterSelected3 ? "1":"0");
        if(this.isManfMonthFilterSelected3){
          this._dataService2.setCookie('s-manfmonth-val3', this.manfMonthFilter3.getCookieStr());
        }

        this._dataService2.setCookie('s-revmonth-sel4', this.isRevMonthFilterSelected4 ? "1":"0");
        if(this.isRevMonthFilterSelected4){
          this._dataService2.setCookie('s-revmonth-val4', this.revMonthFilter4.getCookieStr());
        }
        this._dataService2.setCookie('s-invoicingmonth-sel4', this.isInvMonthFilterSelected4 ? "1":"0");
        if(this.isInvMonthFilterSelected4){
          this._dataService2.setCookie('s-invoicingmonth-val4', this.InvMonthFilter4.getCookieStr());
        }
        this._dataService2.setCookie('s-manfmonth-sel4', this.isManfMonthFilterSelected4 ? "1":"0");
        if(this.isManfMonthFilterSelected4){
          this._dataService2.setCookie('s-manfmonth-val4', this.manfMonthFilter4.getCookieStr());
        }

        this._dataService2.setCookie('s-revmonth-sel5', this.isRevMonthFilterSelected5 ? "1":"0");
        if(this.isRevMonthFilterSelected5){
          this._dataService2.setCookie('s-revmonth-val5', this.revMonthFilter5.getCookieStr());
        }
        this._dataService2.setCookie('s-invoicingmonth-sel5', this.isInvMonthFilterSelected5 ? "1":"0");
        if(this.isInvMonthFilterSelected5){
          this._dataService2.setCookie('s-invoicingmonth-val5', this.InvMonthFilter5.getCookieStr());
        }
        this._dataService2.setCookie('s-manfmonth-sel5', this.isManfMonthFilterSelected5 ? "1":"0");
        if(this.isManfMonthFilterSelected5){
          this._dataService2.setCookie('s-manfmonth-val5', this.manfMonthFilter5.getCookieStr());
        }

        this._dataService2.setCookie('s-revmonth-sel6', this.isRevMonthFilterSelected6 ? "1":"0");
        if(this.isRevMonthFilterSelected6){
          this._dataService2.setCookie('s-revmonth-val6', this.revMonthFilter6.getCookieStr());
        }
        this._dataService2.setCookie('s-invoicingmonth-sel6', this.isInvMonthFilterSelected6 ? "1":"0");
        if(this.isInvMonthFilterSelected6){
          this._dataService2.setCookie('s-invoicingmonth-val6', this.InvMonthFilter6.getCookieStr());
        }
        this._dataService2.setCookie('s-manfmonth-sel6', this.isManfMonthFilterSelected6 ? "1":"0");
        if(this.isManfMonthFilterSelected6){
          this._dataService2.setCookie('s-manfmonth-val6', this.manfMonthFilter6.getCookieStr());
        }
       
      }
      loadSettingsFromCookies(){
        // let _tmpSearch1:string = this._dataService2.getCookie('s-search2');
        // if(_tmpSearch1){
        //   this.search1 = _tmpSearch1;
        // }
        let _tmpRevMonthSel:string = this._dataService2.getCookie('s-revmonth-sel2');
        if(_tmpRevMonthSel){
          this.isRevMonthFilterSelected2 = (_tmpRevMonthSel == "1");
    
          let _tmpRevMonthVal:string = this._dataService2.getCookie('s-revmonth-val2');
          if(_tmpRevMonthVal){
            this.revMonthFilter2 = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
          }
        }
        let _tmpInvMonthSel:string = this._dataService2.getCookie('s-invoicingmonth-sel2');
        if(_tmpInvMonthSel){
          this.isInvMonthFilterSelected2 = (_tmpInvMonthSel == "1");
    
          let _tmpInvMonthVal:string = this._dataService2.getCookie('s-invoicingmonth-val2');
          if(_tmpInvMonthVal){
            this.InvMonthFilter2 = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
          }
        }
        let _tmpManfMonthSel:string = this._dataService2.getCookie('s-manfmonth-sel2');
        if(_tmpManfMonthSel){
          this.isManfMonthFilterSelected2 = (_tmpManfMonthSel == "1");
    
          let _tmpManfMonthVal:string = this._dataService2.getCookie('s-manfmonth-val2');
          if(_tmpManfMonthVal){
            this.manfMonthFilter2 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
          }
        }
       

        let _tmpRevMonthSel3:string = this._dataService2.getCookie('s-revmonth-sel3');
        if(_tmpRevMonthSel3){
          this.isRevMonthFilterSelected3 = (_tmpRevMonthSel3 == "1");
    
          let _tmpRevMonthVal:string = this._dataService2.getCookie('s-revmonth-val3');
          if(_tmpRevMonthVal){
            this.revMonthFilter3 = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
          }
        }
        let _tmpInvMonthSel3:string = this._dataService2.getCookie('s-invoicingmonth-sel3');
        if(_tmpInvMonthSel3){
          this.isInvMonthFilterSelected3 = (_tmpInvMonthSel3 == "1");
    
          let _tmpInvMonthVal:string = this._dataService2.getCookie('s-invoicingmonth-val3');
          if(_tmpInvMonthVal){
            this.InvMonthFilter3 = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
          }
        }
        let _tmpManfMonthSel3:string = this._dataService2.getCookie('s-manfmonth-sel3');
        if(_tmpManfMonthSel3){
          this.isManfMonthFilterSelected3 = (_tmpManfMonthSel3 == "1");
    
          let _tmpManfMonthVal:string = this._dataService2.getCookie('s-manfmonth-val3');
          if(_tmpManfMonthVal){
            this.manfMonthFilter3 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
          }
        }

        let _tmpRevMonthSel4:string = this._dataService2.getCookie('s-revmonth-sel4');
        if(_tmpRevMonthSel4){
          this.isRevMonthFilterSelected4 = (_tmpRevMonthSel4 == "1");
    
          let _tmpRevMonthVal:string = this._dataService2.getCookie('s-revmonth-val4');
          if(_tmpRevMonthVal){
            this.revMonthFilter4 = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
          }
        }
        let _tmpInvMonthSel4:string = this._dataService2.getCookie('s-invoicingmonth-sel4');
        if(_tmpInvMonthSel4){
          this.isInvMonthFilterSelected4 = (_tmpInvMonthSel4 == "1");
    
          let _tmpInvMonthVal:string = this._dataService2.getCookie('s-invoicingmonth-val4');
          if(_tmpInvMonthVal){
            this.InvMonthFilter4 = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
          }
        }
        let _tmpManfMonthSel4:string = this._dataService2.getCookie('s-manfmonth-sel4');
        if(_tmpManfMonthSel4){
          this.isManfMonthFilterSelected4 = (_tmpManfMonthSel4 == "1");
    
          let _tmpManfMonthVal:string = this._dataService2.getCookie('s-manfmonth-val4');
          if(_tmpManfMonthVal){
            this.manfMonthFilter4 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
          }
        }

        let _tmpRevMonthSel5:string = this._dataService2.getCookie('s-revmonth-sel5');
        if(_tmpRevMonthSel5){
          this.isRevMonthFilterSelected5 = (_tmpRevMonthSel5 == "1");
    
          let _tmpRevMonthVal:string = this._dataService2.getCookie('s-revmonth-val5');
          if(_tmpRevMonthVal){
            this.revMonthFilter5 = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
          }
        }
        let _tmpInvMonthSel5:string = this._dataService2.getCookie('s-invoicingmonth-sel5');
        if(_tmpInvMonthSel5){
          this.isInvMonthFilterSelected5 = (_tmpInvMonthSel5 == "1");
    
          let _tmpInvMonthVal:string = this._dataService2.getCookie('s-invoicingmonth-val5');
          if(_tmpInvMonthVal){
            this.InvMonthFilter5 = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
          }
        }
        let _tmpManfMonthSel5:string = this._dataService2.getCookie('s-manfmonth-sel5');
        if(_tmpManfMonthSel5){
          this.isManfMonthFilterSelected5 = (_tmpManfMonthSel5 == "1");
    
          let _tmpManfMonthVal:string = this._dataService2.getCookie('s-manfmonth-val5');
          if(_tmpManfMonthVal){
            this.manfMonthFilter5 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
          }
        }

        let _tmpRevMonthSel6:string = this._dataService2.getCookie('s-revmonth-sel6');
        if(_tmpRevMonthSel6){
          this.isRevMonthFilterSelected6 = (_tmpRevMonthSel6 == "1");
    
          let _tmpRevMonthVal:string = this._dataService2.getCookie('s-revmonth-val6');
          if(_tmpRevMonthVal){
            this.revMonthFilter6 = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
          }
        }
        let _tmpInvMonthSel6:string = this._dataService2.getCookie('s-invoicingmonth-sel6');
        if(_tmpInvMonthSel6){
          this.isInvMonthFilterSelected6 = (_tmpInvMonthSel6 == "1");
    
          let _tmpInvMonthVal:string = this._dataService2.getCookie('s-invoicingmonth-val6');
          if(_tmpInvMonthVal){
            this.InvMonthFilter6 = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
          }
        }
        let _tmpManfMonthSel6:string = this._dataService2.getCookie('s-manfmonth-sel6');
        if(_tmpManfMonthSel6){
          this.isManfMonthFilterSelected6 = (_tmpManfMonthSel6 == "1");
    
          let _tmpManfMonthVal:string = this._dataService2.getCookie('s-manfmonth-val6');
          if(_tmpManfMonthVal){
            this.manfMonthFilter6 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
          }
        }
       
        // let _tmpTableOptions:string = this._dataService2.getCookie('s-table-opts2');
        // if(_tmpTableOptions){
        //   let _optTokens:Array<string> = _tmpTableOptions.split(',');
  
        // if(_optTokens.length >= 3){
        //   if(_optTokens[3]){
        //     this.orderStatusId2 = _optTokens[3];
        //   }
        //     this.variantTypeId2 = _optTokens[0];
        //     this.quantityTypeId2 = _optTokens[1];
             
        //  }
        // }
    
        let _currDate:Date = new Date();
        if(this.revMonthFilter2 == null){
          this.revMonthFilter2 = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
          _currDate.getMonth()+1, _currDate.getFullYear());
        }
        if(this.InvMonthFilter2 == null){
          this.InvMonthFilter2 = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
          _currDate.getMonth()+1, _currDate.getFullYear());
        }
        if(this.manfMonthFilter2 == null){
          this.manfMonthFilter2 = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
          _currDate.getMonth()+1, _currDate.getFullYear());
        }

        let _currDate3:Date = new Date();
        if(this.revMonthFilter3 == null){
          this.revMonthFilter3 = new monthFilter(_currDate3.getMonth()+1, _currDate3.getFullYear(),
          _currDate3.getMonth()+1, _currDate3.getFullYear());
        }
        if(this.InvMonthFilter3 == null){
          this.InvMonthFilter3 = new monthFilter(_currDate3.getMonth()+1, _currDate3.getFullYear(),
          _currDate3.getMonth()+1, _currDate3.getFullYear());
        }
        if(this.manfMonthFilter3 == null){
          this.manfMonthFilter3 = new monthFilter(_currDate3.getMonth()+1, _currDate3.getFullYear(),
          _currDate3.getMonth()+1, _currDate3.getFullYear());
        }

        let _currDate4:Date = new Date();
        if(this.revMonthFilter4 == null){
          this.revMonthFilter4 = new monthFilter(_currDate4.getMonth()+1, _currDate4.getFullYear(),
          _currDate4.getMonth()+1, _currDate4.getFullYear());
        }
        if(this.InvMonthFilter4 == null){
          this.InvMonthFilter4 = new monthFilter(_currDate4.getMonth()+1, _currDate4.getFullYear(),
          _currDate4.getMonth()+1, _currDate4.getFullYear());
        }
        if(this.manfMonthFilter4 == null){
          this.manfMonthFilter4 = new monthFilter(_currDate4.getMonth()+1, _currDate4.getFullYear(),
          _currDate4.getMonth()+1, _currDate4.getFullYear());
        }

        let _currDate5:Date = new Date();
        if(this.revMonthFilter5 == null){
          this.revMonthFilter5 = new monthFilter(_currDate5.getMonth()+1, _currDate5.getFullYear(),
          _currDate5.getMonth()+1, _currDate5.getFullYear());
        }
        if(this.InvMonthFilter5 == null){
          this.InvMonthFilter5 = new monthFilter(_currDate5.getMonth()+1, _currDate5.getFullYear(),
          _currDate5.getMonth()+1, _currDate5.getFullYear());
        }
        if(this.manfMonthFilter5 == null){
          this.manfMonthFilter5 = new monthFilter(_currDate5.getMonth()+1, _currDate5.getFullYear(),
          _currDate5.getMonth()+1, _currDate5.getFullYear());
        }

        let _currDate6:Date = new Date();
        if(this.revMonthFilter6 == null){
          this.revMonthFilter6 = new monthFilter(_currDate6.getMonth()+1, _currDate6.getFullYear(),
          _currDate6.getMonth()+1, _currDate6.getFullYear());
        }
        if(this.InvMonthFilter6 == null){
          this.InvMonthFilter6 = new monthFilter(_currDate6.getMonth()+1, _currDate6.getFullYear(),
          _currDate6.getMonth()+1, _currDate6.getFullYear());
        }
        if(this.manfMonthFilter6 == null){
          this.manfMonthFilter6 = new monthFilter(_currDate6.getMonth()+1, _currDate6.getFullYear(),
          _currDate6.getMonth()+1, _currDate6.getFullYear());
        }
      }
      loadData() {
        this.isLoading2 = true;
        this._dataService2.getDataDefinitions().subscribe(res => {
          this._dataService2.getAllSalesOrder(1).subscribe((_soObjAr2:Array<SalesOrder>) => {
            this._soObjList2 = _soObjAr2.filter((_tmpSO2:SalesOrder) => {
              //test the filter.
              // if(_tmpSO2.projectStatus == SOStatus.Dispatched || _tmpSO2.projectStatus == SOStatus.Archived)
              if(_tmpSO2.projectStatus == SOStatus.Dispatched)
              {
                return false;
              }
              return true;
            });
            this.filterRows();
            this.filterRows3();
            this.filterRows4();
            this.filterRows5();
            this.filterRows6();
          });
        });
      }
  
      getClassName(_temp: number): string {
        if (_temp < 6) {
          return "bg-grey";
        } else if (_temp >= 6 && _temp < 10) {
          return "bg-yellow";
        } else if (_temp > 10) {
          return "bg-green";
        }
      }
     

    
      reloadData(): void {
        this.isLoading2 = true;
        this.loadData();
      }
      clearFilters(): void{
        // this.search1 = '';
        this.isRevMonthFilterSelected2 = false;
        this.isInvMonthFilterSelected2 = false;
        this.isManfMonthFilterSelected2 = false;     

        this.isRevMonthFilterSelected3 = false;
        this.isInvMonthFilterSelected3 = false;
        this.isManfMonthFilterSelected3 = false; 
        
        this.isRevMonthFilterSelected4 = false;
        this.isInvMonthFilterSelected4 = false;
        this.isManfMonthFilterSelected4 = false;

        this.isRevMonthFilterSelected5 = false;
        this.isInvMonthFilterSelected5 = false;
        this.isManfMonthFilterSelected5 = false;

        this.isRevMonthFilterSelected6 = false;
        this.isInvMonthFilterSelected6 = false;
        this.isManfMonthFilterSelected6 = false;
    
        this.isLoading2 = true;
        this.loadData();
    
        setTimeout(() => {
          this.saveSettingsToCookies();
        }, 10);
      }
    
     
   
      filterRows(): void {
        this.isLoading2 = true;
        setTimeout(() => {
          this.filterRowsLogic2();  
          this.isLoading2 = false;
        }, 5);
        this.saveSettingsToCookies();
      }

      filterRows3(): void {
        this.isLoading2 = true;
        setTimeout(() => {
          this.filterRowsLogic3();  
          this.isLoading2 = false;
        }, 5);
        this.saveSettingsToCookies();
      }

      filterRows4(): void {
        this.isLoading2 = true;
        setTimeout(() => {
          this.filterRowsLogic4();  
          this.isLoading2 = false;
        }, 5);
        this.saveSettingsToCookies();
      }

      filterRows5(): void {
        this.isLoading2 = true;
        setTimeout(() => {
          this.filterRowsLogic5();  
          this.isLoading2 = false;
        }, 5);
        this.saveSettingsToCookies();
      }

      filterRows6(): void {
        this.isLoading2 = true;
        setTimeout(() => {
          this.filterRowsLogic6();  
          this.isLoading2 = false;
        }, 5);
        this.saveSettingsToCookies();
      }

    
      // private _searchKeyTimer:any;
      // searchInputChanged(){
      //   if(this._searchKeyTimer){
      //     clearTimeout(this._searchKeyTimer);
      //   }
      //   this._searchKeyTimer = setTimeout(() => {
      //     this.filterRows();
      //   // }, (this.search1.length < 5 ? 700 : 500));
      // },500);
      // }
    
      private displaySOwithNoSSO(){
        if(this.isRevMonthFilterSelected2 == true ||this.isInvMonthFilterSelected2 == true || this.isManfMonthFilterSelected2 == true
         
          ){
            return false;
          }
    
        return true;
      }

      private displaySOwithNoSSO3(){
        if(this.isRevMonthFilterSelected3 == true ||this.isInvMonthFilterSelected3 == true || this.isManfMonthFilterSelected3 == true
          ){
            return false;
          }
    
        return true;
      }

      private displaySOwithNoSSO4(){
        if(this.isRevMonthFilterSelected4 == true ||this.isInvMonthFilterSelected4 == true || this.isManfMonthFilterSelected4 == true 
          ){
            return false;
          }
    
        return true;
      }
      private displaySOwithNoSSO5(){
        if(
          this.isRevMonthFilterSelected5 == true ||this.isInvMonthFilterSelected5 == true || this.isManfMonthFilterSelected5 == true
          ){
            return false;
          }
    
        return true;
      }
      private displaySOwithNoSSO6(){
        if(
          this.isRevMonthFilterSelected6 == true ||this.isInvMonthFilterSelected6 == true || this.isManfMonthFilterSelected6 == true 
          ){
            return false;
          }
    
        return true;
      }

      filterRowsLogic2(){
        //console.log(1, (new Date()).getTime());
        let _tmpSaleOrderArray2: Array<UiWaitReadySO> = [];
        let _tmpSOCounter2: number = 0;
        let _tmpSSOCounter2: number = 0; 

        let  _tmppanelsManf1: number = 0;
        let _tmpcostManf1: number = 0;
        let _tmppanelsManf2: number = 0;
        let _tmpcostManf2: number = 0;
        let _tmppanelsManf3: number = 0;
        let _tmpcostManf3: number = 0;
        let _tmppanelsManf4: number = 0;
        let _tmpcostManf4: number = 0;

        let _tmppanelsTesting1: number = 0;
        let _tmpcostTesting1: number = 0;
        let _tmppanelsTesting2: number = 0;
        let _tmpcostTesting2: number = 0;
        let _tmppanelsTesting3: number = 0;
        let _tmpcostTesting3: number = 0;
        let _tmppanelsTesting4: number = 0;
        let _tmpcostTesting4: number = 0;

        let _tmppanelsFAT1: number = 0;
        let _tmpcostFAT1: number = 0;
        let _tmppanelsFAT2: number = 0;
        let _tmpcostFAT2: number = 0;
        let _tmppanelsFAT3: number = 0;
        let _tmpcostFAT3: number = 0;
        let _tmppanelsFAT4: number = 0;
        let _tmpcostFAT4: number = 0;

        let _tmppanelsGreenSticker1: number = 0;
        let _tmpcostGreenSticker1: number = 0;
        let _tmppanelsGreenSticker2: number = 0;
        let _tmpcostGreenSticker2: number = 0;
        let _tmppanelsGreenSticker3: number = 0;
        let _tmpcostGreenSticker3: number = 0;
        let _tmppanelsGreenSticker4: number = 0;
        let _tmpcostGreenSticker4: number = 0;

        let _tmppanelsDispatch1: number = 0;
        let _tmpcostDispatch1: number = 0;
        let _tmppanelsDispatch2: number = 0;
        let _tmpcostDispatch2: number = 0;
        let _tmppanelsDispatch3: number = 0;
        let _tmpcostDispatch3: number = 0;
        let _tmppanelsDispatch4: number = 0;
        let _tmpcostDispatch4: number = 0;

        // let _tmpCT1: number = 0;
        // let _tmpCT2: number = 0;
        // let _tmpCT3: number = 0;
        // let _tmpCT4: number = 0;

        // let _tmpBrkrMch1: number = 0;
        // let _tmpBrkrMch2: number = 0;
        // let _tmpBrkrMch3: number = 0;
        // let _tmpBrkrMch4: number = 0;

        // let _tmpCTreq1: number = 0;
        // let _tmpCTreq2: number = 0;
        // let _tmpCTreq3: number = 0;
        // let _tmpCTreq4: number = 0;

        // let _tmpMBreq1: number = 0;
        // let _tmpMBreq2: number = 0;
        // let _tmpMBreq3: number = 0;
        // let _tmpMBreq4: number = 0;

        // let _tmpCTact1: number = 0;
        // let _tmpCTact2: number = 0;
        // let _tmpCTact3: number = 0;
        // let _tmpCTact4: number = 0;

        // let _tmpMBact1: number = 0;
        // let _tmpMBact2: number = 0;
        // let _tmpMBact3: number = 0;
        // let _tmpMBact4: number = 0;


        let _showSOWithNoSSO2:boolean = this.displaySOwithNoSSO();
  
    
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO2: SalesOrder = this._soObjList2[i];  
          
          let _isSOPassedFilter2:boolean = true;
          if(_isSOPassedFilter2 == true){
            var _filteredSSO2:Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO2.subSalesOrder);
  
            if(_filteredSSO2.length > 0 || (_tmpSO2.subSalesOrder.length == 0 && _showSOWithNoSSO2 == true)){
            
               _tmpSOCounter2++;
              
              let _tmpUISSoEqObj2:UiWaitReadySO;
                           
              _filteredSSO2.forEach((_tmpSSO2:SubSalesOrder) => {

              
                // UNDER MANUFACTURING LOGIC 

                if (_tmpSSO2.productionIP.lineLoadingActualDate != null && _tmpSSO2.productionIP.mechanicalStickerActualDate == null) {

                  let _d = new Date().getTime() - _tmpSSO2.productionIP.lineLoadingActualDate.getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);
                  let _caseDays: number = 0;
                  let _typeD: string;
                  if (_daysDiff >= 0 && _daysDiff <= 5) {
                    _caseDays = 1;
                    _typeD = "0 - 5 days";
                  }
                  else if (_daysDiff > 5 && _daysDiff <= 10) {
                    _caseDays = 2;
                    _typeD = "5 - 10 days";
                  }
                  else if (_daysDiff > 10 && _daysDiff <= 20) {
                    _caseDays = 3;
                    _typeD = "10 - 20 days";
                  } else if (_daysDiff > 20) {
                    _caseDays = 4;
                    _typeD = "> 20 days";
                  }
                    if(_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0 ){
                    switch (_caseDays) {
                      case 1:
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsManf1 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostManf1 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 2:
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsManf2 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostManf2 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 3:
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsManf3 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostManf3 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 4:
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsManf4 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostManf4 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                    }

                    _tmpUISSoEqObj2 = new UiWaitReadySO(_tmpSO2.marketingIP.salesOrderNo, _tmpSSO2.subOrderNoId, _tmpSO2.marketingIP.customerName, _tmpSO2.pmCommercial.isSaleOrderChangeApplicable, _tmpSO2.pmCommercial.salesOrderNoNew, "Under Manufacturing", this._dataService2.getProductVariantName(_tmpSSO2.pmTechSubSalesOrder.productVarient), _tmpSSO2.pmTechSubSalesOrder.panelQuantity || _tmpSSO2.pmTechSubSalesOrder.panelQuantity!= null ? _tmpSSO2.pmTechSubSalesOrder.panelQuantity:0,_caseDays,_typeD);
                    _tmpSaleOrderArray2.push(_tmpUISSoEqObj2);

                  }
               
                }


                // UNDER TESTING LOGIC 

                if (_tmpSSO2.productionIP.mechanicalStickerActualDate != null && _tmpSSO2.qualityIP.mechanicalElectricalTestingActualDate == null) {

                  let _d = new Date().getTime() - _tmpSSO2.productionIP.mechanicalStickerActualDate.getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);
                  let _caseDays: number = 0;
                  let _typeD: string;
                  if (_daysDiff >= 0 && _daysDiff <= 5) {
                    _caseDays = 1;
                   
                  }
                  else if (_daysDiff > 5 && _daysDiff <= 10) {
                    _caseDays = 2;
                    
                  }
                  else if (_daysDiff > 10 && _daysDiff <= 20) {
                    _caseDays = 3;
                    
                  } else if (_daysDiff > 20) {
                    _caseDays = 4;
                  
                  }
                  
                    if(_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0 ){

                      switch (_caseDays) {
                      case 1:
                        _typeD = "0 - 5 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsTesting1 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostTesting1 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 2:
                        _typeD = "5 - 10 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsTesting2 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostTesting2 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 3:
                        _typeD = "10 - 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsTesting3 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostTesting3 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 4:
                        _typeD = "> 20 days";
                        if ( _tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsTesting4 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostTesting4 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                    }
                    
                    _tmpUISSoEqObj2 = new UiWaitReadySO(_tmpSO2.marketingIP.salesOrderNo, _tmpSSO2.subOrderNoId, _tmpSO2.marketingIP.customerName, _tmpSO2.pmCommercial.isSaleOrderChangeApplicable, _tmpSO2.pmCommercial.salesOrderNoNew, "Under Testing", this._dataService2.getProductVariantName(_tmpSSO2.pmTechSubSalesOrder.productVarient), _tmpSSO2.pmTechSubSalesOrder.panelQuantity || _tmpSSO2.pmTechSubSalesOrder.panelQuantity != null ? _tmpSSO2.pmTechSubSalesOrder.panelQuantity : 0, _caseDays, _typeD);
                    _tmpSaleOrderArray2.push(_tmpUISSoEqObj2);
                  }


                }

                // UNDER FAT LOGIC 

                if (_tmpSSO2.qualityIP.mechanicalElectricalTestingActualDate != null && _tmpSSO2.qualityIP.fatActualDate == null) {

                  let _d = new Date().getTime() - _tmpSSO2.qualityIP.mechanicalElectricalTestingActualDate.getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);
                  let _caseDays: number = 0;
                  let _typeD: string;
                  if (_daysDiff >= 0 && _daysDiff <= 5) {
                    _caseDays = 1;
                    
                  }
                  else if (_daysDiff > 5 && _daysDiff <= 10) {
                    _caseDays = 2;
                    
                  }
                  else if (_daysDiff > 10 && _daysDiff <= 20) {
                    _caseDays = 3;
                    
                  } else if (_daysDiff > 20) {
                    _caseDays = 4;
                   
                  }
                    if(_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0 ){

                    switch (_caseDays) {
                      case 1:
                        _typeD = "0 - 5 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsFAT1 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostFAT1 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 2:
                        _typeD = "5 - 10 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsFAT2 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostFAT2 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 3:
                        _typeD = "10 - 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsFAT3 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostFAT3 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 4:
                        _typeD = "> 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsFAT4 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostFAT4 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                    }

                    _tmpUISSoEqObj2 = new UiWaitReadySO(_tmpSO2.marketingIP.salesOrderNo, _tmpSSO2.subOrderNoId, _tmpSO2.marketingIP.customerName, _tmpSO2.pmCommercial.isSaleOrderChangeApplicable, _tmpSO2.pmCommercial.salesOrderNoNew, "Under FAT", this._dataService2.getProductVariantName(_tmpSSO2.pmTechSubSalesOrder.productVarient), _tmpSSO2.pmTechSubSalesOrder.panelQuantity || _tmpSSO2.pmTechSubSalesOrder.panelQuantity!= null ? _tmpSSO2.pmTechSubSalesOrder.panelQuantity:0,_caseDays,_typeD);
                    _tmpSaleOrderArray2.push(_tmpUISSoEqObj2);
                  }

                }

                // UNDER GREEN STICKER LOGIC 

                if (_tmpSSO2.qualityIP.fatActualDate  != null && _tmpSSO2.qualityIP.greenStickerActualDate == null) {


                  let _d = new Date().getTime() - _tmpSSO2.qualityIP.fatActualDate .getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);
                  let _caseDays: number = 0;
                  let _typeD: string;
                  if (_daysDiff >= 0 && _daysDiff <= 5) {
                    _caseDays = 1;
                   
                  }
                  else if (_daysDiff > 5 && _daysDiff <= 10) {
                    _caseDays = 2;
                   
                  }
                  else if (_daysDiff > 10 && _daysDiff <= 20) {
                    _caseDays = 3;
                   
                  } else if (_daysDiff > 20) {
                    _caseDays = 4;
                   
                  }
                    if(_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0 ){


                    switch (_caseDays) {
                      case 1:
                        _typeD = "0 - 5 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsGreenSticker1 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostGreenSticker1 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 2:
                        _typeD = "5 - 10 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsGreenSticker2 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostGreenSticker2 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 3:
                        _typeD = "10 - 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsGreenSticker3 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostGreenSticker3 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 4:
                        _typeD = "> 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsGreenSticker4 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostGreenSticker4 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                    }


                    _tmpUISSoEqObj2 = new UiWaitReadySO(_tmpSO2.marketingIP.salesOrderNo, _tmpSSO2.subOrderNoId, _tmpSO2.marketingIP.customerName, _tmpSO2.pmCommercial.isSaleOrderChangeApplicable, _tmpSO2.pmCommercial.salesOrderNoNew, "Under Green Sticker", this._dataService2.getProductVariantName(_tmpSSO2.pmTechSubSalesOrder.productVarient), _tmpSSO2.pmTechSubSalesOrder.panelQuantity || _tmpSSO2.pmTechSubSalesOrder.panelQuantity!= null ? _tmpSSO2.pmTechSubSalesOrder.panelQuantity:0,_caseDays,_typeD);
                    _tmpSaleOrderArray2.push(_tmpUISSoEqObj2);  
                  }

                }

                 // UNDER DISPATCH LOGIC                  

                 if (_tmpSSO2.qualityIP.greenStickerActualDate  != null && _tmpSSO2.logisticIP.lastDeliveryActualDate == null) {
                  let _d = new Date().getTime() - _tmpSSO2.qualityIP.greenStickerActualDate .getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);
                  let _caseDays: number = 0;
                  let _typeD: string;
                  if (_daysDiff >= 0 && _daysDiff <= 5) {
                    _caseDays = 1;
                   
                  }
                  else if (_daysDiff > 5 && _daysDiff <= 10) {
                    _caseDays = 2;
                  
                  }
                  else if (_daysDiff > 10 && _daysDiff <= 20) {
                    _caseDays = 3;
                   
                  } else if (_daysDiff > 20) {
                    _caseDays = 4;
                   
                  }
                    if(_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0 ){

                    switch (_caseDays) {
                      case 1:
                        _typeD = "0 - 5 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsDispatch1 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostDispatch1 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 2:
                        _typeD = "5 - 10 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsDispatch2 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostDispatch2 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 3:
                        _typeD = "10 - 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsDispatch3 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostDispatch3 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }
                        break;
                      case 4:
                        _typeD = "> 20 days";
                        if (_tmpSSO2.pmTechSubSalesOrder.panelQuantity > 0) {
                          _tmppanelsDispatch4 += _tmpSSO2.pmTechSubSalesOrder.panelQuantity;
                        }
                        if (_tmpSSO2.pmTechSubSalesOrder.contractualValue > 0) {
                          _tmpcostDispatch4 += _tmpSSO2.pmTechSubSalesOrder.contractualValue;
                        }

                        break;
                    }


                    _tmpUISSoEqObj2 = new UiWaitReadySO(_tmpSO2.marketingIP.salesOrderNo, _tmpSSO2.subOrderNoId, _tmpSO2.marketingIP.customerName, _tmpSO2.pmCommercial.isSaleOrderChangeApplicable, _tmpSO2.pmCommercial.salesOrderNoNew, "Under Dispatch", this._dataService2.getProductVariantName(_tmpSSO2.pmTechSubSalesOrder.productVarient), _tmpSSO2.pmTechSubSalesOrder.panelQuantity || _tmpSSO2.pmTechSubSalesOrder.panelQuantity!= null ? _tmpSSO2.pmTechSubSalesOrder.panelQuantity:0,_caseDays,_typeD);
                   _tmpSaleOrderArray2.push(_tmpUISSoEqObj2);

                  }

                }

              //   //// CT STAGGERED DELIVERY REPORT

              //   if(_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptDate != null){
              //     if(_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptFirstDate != null){
                    
              //     let _d =_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptDate.getTime() - _tmpSSO2.purchaseMatReceipt.ctPTActualReceiptFirstDate.getTime()
              //     let _daysDiff = _d / (1000 * 3600 * 24);

              //     let _caseDays: number = 0;
              //     if (_daysDiff >= 0 && _daysDiff <= 5) {
              //       _caseDays = 1;
              //     }
              //     else if (_daysDiff > 5 && _daysDiff <= 10) {
              //       _caseDays = 2;
              //     }
              //     else if (_daysDiff > 10) {
              //       _caseDays = 3;
              //     } 
              //     switch(_caseDays){
              //       case 1 : _tmpCT1++;
              //         break;
              //         case 2 : _tmpCT2++;
              //         break;
              //         case 3 : _tmpCT3++;
              //         break;
                      

              //     }

              //     }
              //     else{
              //       _tmpCT4++;
              //     }
                  
              //   }

              //  //// BREAKER RECEIPT MONITORING REPORT

              //  if(_tmpSSO2.purchaseMatReceipt.breakerActualReceiptDate != null && _tmpSSO2.productionIP.mechanicalStickerActualDate  != null){
                 
              //   let _d =_tmpSSO2.purchaseMatReceipt.breakerActualReceiptDate.getTime() - _tmpSSO2.productionIP.mechanicalStickerActualDate.getTime()
              //   let _daysDiff = _d / (1000 * 3600 * 24);

              //   let _caseDays: number = 0;
              //   if (_daysDiff <= -5) {
              //     _caseDays = 1;
              //   }
              //   else if (_daysDiff > -5 && _daysDiff <= -3) {
              //     _caseDays = 2;
              //   }
              //   else if (_daysDiff > -2 && _daysDiff <= 2) {
              //     _caseDays = 3;
              //   }else if (_daysDiff > 3) {
              //     _caseDays = 4;
              //   } 
              //   switch(_caseDays){
              //     case 1 : _tmpBrkrMch1++;
              //       break;
              //       case 2 : _tmpBrkrMch2++;
              //       break;
              //       case 3 : _tmpBrkrMch3++;
              //       break;
              //       case 4 : _tmpBrkrMch4++;
              //       break;
                    

              //   }
                
              // }

              //   //// CT & MB WRT REQUESTED LINE LOADING REPORT

              //   if(_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptDate != null && _tmpSSO2.purchaseMatReceipt.meteringBoxActualReceiptDate  != null && _tmpSSO2.planningIP.requestedLineLoadingDate != null
              //      && _tmpSSO2.productionIP.lineLoadingActualDate == null ){
                 
              //     let _d =_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptDate.getTime() - _tmpSSO2.planningIP.requestedLineLoadingDate.getTime()
              //     let _daysDiff = _d / (1000 * 3600 * 24);
              //       console.log("_daysDiff",_daysDiff);
                    
              //     let _caseDays: number = 0;
              //     if (_daysDiff < -5) {
              //       _caseDays = 1;
              //     }
              //     else if (_daysDiff > -5 && _daysDiff <= -4) {
              //       _caseDays = 2;
              //     }
              //     else if (_daysDiff == -3 ) {
              //       _caseDays = 3;
              //     }else if (_daysDiff > 0) {
              //       _caseDays = 4;
              //     } 
              //     switch(_caseDays){
              //       case 1 : _tmpCTreq1++;
              //         break;
              //         case 2 : _tmpCTreq2++;
              //         break;
              //         case 3 : _tmpCTreq3++;
              //         break;
              //         case 4 : _tmpCTreq4++;
              //         break;
                      
  
              //     }

              //     let _d1 =_tmpSSO2.purchaseMatReceipt.meteringBoxActualReceiptDate.getTime() - _tmpSSO2.planningIP.requestedLineLoadingDate.getTime()
              //     let _daysDiff1 = _d1 / (1000 * 3600 * 24);
  
              //     let _caseDays1: number = 0;
              //     if (_daysDiff1 < -5) {
              //       _caseDays1 = 1;
              //     }
              //     else if (_daysDiff1 > -5 && _daysDiff1 <= -4) {
              //       _caseDays1 = 2;
              //     }
              //     else if (_daysDiff1 == -3 ) {
              //       _caseDays1 = 3;
              //     }else if (_daysDiff1 > 0) {
              //       _caseDays1 = 4;
              //     } 
              //     switch(_caseDays1){
              //       case 1 : _tmpMBreq1++;
              //         break;
              //         case 2 : _tmpMBreq2++;
              //         break;
              //         case 3 : _tmpMBreq3++;
              //         break;
              //         case 4 : _tmpMBreq4++;
              //         break;
                      
  
              //     }
                  
              //   }


              //    //// CT & MB WRT ACTUAL LINE LOADING REPORT

              //    if(_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptDate != null && _tmpSSO2.purchaseMatReceipt.meteringBoxActualReceiptDate  != null  && _tmpSSO2.productionIP.lineLoadingActualDate != null ){
                
              //    let _d =_tmpSSO2.purchaseMatReceipt.ctPTActualReceiptDate.getTime() - _tmpSSO2.productionIP.lineLoadingActualDate.getTime()
              //    let _daysDiff = _d / (1000 * 3600 * 24);
              //      console.log("_daysDiff",_daysDiff);
                   
              //    let _caseDays: number = 0;
              //    if (_daysDiff < -5) {
              //      _caseDays = 1;
              //    }
              //    else if (_daysDiff > -5 && _daysDiff <= -4) {
              //      _caseDays = 2;
              //    }
              //    else if (_daysDiff == -3 ) {
              //      _caseDays = 3;
              //    }else if (_daysDiff > 0) {
              //      _caseDays = 4;
              //    } 
              //    switch(_caseDays){
              //      case 1 : _tmpCTact1++;
              //        break;
              //        case 2 : _tmpCTact2++;
              //        break;
              //        case 3 : _tmpCTact3++;
              //        break;
              //        case 4 : _tmpCTact4++;
              //        break;
                     
 
              //    }

              //    let _d1 =_tmpSSO2.purchaseMatReceipt.meteringBoxActualReceiptDate.getTime() - _tmpSSO2.productionIP.lineLoadingActualDate.getTime()
              //    let _daysDiff1 = _d1 / (1000 * 3600 * 24);
 
              //    let _caseDays1: number = 0;
              //    if (_daysDiff1 < -5) {
              //      _caseDays1 = 1;
              //    }
              //    else if (_daysDiff1 > -5 && _daysDiff1 <= -4) {
              //      _caseDays1 = 2;
              //    }
              //    else if (_daysDiff1 == -3 ) {
              //      _caseDays1 = 3;
              //    }else if (_daysDiff1 > 0) {
              //      _caseDays1 = 4;
              //    } 
              //    switch(_caseDays1){
              //      case 1 : _tmpMBact1++;
              //        break;
              //        case 2 : _tmpMBact2++;
              //        break;
              //        case 3 : _tmpMBact3++;
              //        break;
              //        case 4 : _tmpMBact4++;
              //        break;
                     
 
              //    }
                 
              //  }

              });
                  _tmpSSOCounter2++;

            }
           
         
          }
         
        } 
       

    
        this.filteredSaleOrderArray2 = _tmpSaleOrderArray2;    
        
        
        this.filteredSOCount2 = _tmpSOCounter2;
        this.filteredSSOCount2 = _tmpSSOCounter2;
   

        this._panelsManf1 =   _tmppanelsManf1;
        this._costManf1=  _tmpcostManf1;
        this._panelsManf2= _tmppanelsManf2;
        this._costManf2= _tmpcostManf2;
        this._panelsManf3= _tmppanelsManf3;
        this._costManf3= _tmpcostManf3;
        this._panelsManf4= _tmppanelsManf4;
        this._costManf4= _tmpcostManf4;

        this._panelsTesting1 =   _tmppanelsTesting1;
        this._costTesting1=  _tmpcostTesting1;
        this._panelsTesting2= _tmppanelsTesting2;
        this._costTesting2= _tmpcostTesting2;
        this._panelsTesting3= _tmppanelsTesting3;
        this._costTesting3= _tmpcostTesting3;
        this._panelsTesting4= _tmppanelsTesting4;
        this._costTesting4= _tmpcostTesting4;

        this._panelsFAT1 =   _tmppanelsFAT1;
        this._costFAT1=  _tmpcostFAT1;
        this._panelsFAT2= _tmppanelsFAT2;
        this._costFAT2= _tmpcostFAT2;
        this._panelsFAT3= _tmppanelsFAT3;
        this._costFAT3= _tmpcostFAT3;
        this._panelsFAT4= _tmppanelsFAT4;
        this._costFAT4= _tmpcostFAT4;

        this._panelsGreenSticker1 =   _tmppanelsGreenSticker1;
        this._costGreenSticker1=  _tmpcostGreenSticker1;
        this._panelsGreenSticker2= _tmppanelsGreenSticker2;
        this._costGreenSticker2= _tmpcostGreenSticker2;
        this._panelsGreenSticker3= _tmppanelsGreenSticker3;
        this._costGreenSticker3= _tmpcostGreenSticker3;
        this._panelsGreenSticker4= _tmppanelsGreenSticker4;
        this._costGreenSticker4= _tmpcostGreenSticker4;

        this._panelsDispatch1 =   _tmppanelsDispatch1;
        this._costDispatch1=  _tmpcostDispatch1;
        this._panelsDispatch2= _tmppanelsDispatch2;
        this._costDispatch2= _tmpcostDispatch2;
        this._panelsDispatch3= _tmppanelsDispatch3;
        this._costDispatch3= _tmpcostDispatch3;
        this._panelsDispatch4= _tmppanelsDispatch4;
        this._costDispatch4= _tmpcostDispatch4;

        // this.CT1 = _tmpCT1;
        // this.CT2 = _tmpCT2;
        // this.CT3 = _tmpCT3;
        // this.CT4 = _tmpCT4;

        // this.BrkrMch1 = !isNaN(Math.round(100 * (_tmpBrkrMch1/ _tmpSSOCounter2))) ? Math.round(100 * (_tmpBrkrMch1/ _tmpSSOCounter2)):0;
        // this.BrkrMch2 = !isNaN(Math.round(100 * (_tmpBrkrMch2/ _tmpSSOCounter2))) ? Math.round(100 * (_tmpBrkrMch2/ _tmpSSOCounter2)):0;
        // this.BrkrMch3 = !isNaN(Math.round(100 * (_tmpBrkrMch3/ _tmpSSOCounter2))) ? Math.round(100 * (_tmpBrkrMch3/ _tmpSSOCounter2)):0;
        // this.BrkrMch4 = !isNaN(Math.round(100 * (_tmpBrkrMch4/ _tmpSSOCounter2))) ? Math.round(100 * (_tmpBrkrMch4/ _tmpSSOCounter2)):0;

        // this.CTreq1 = !isNaN(Math.round(100 * (_tmpCTreq1 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTreq1 / _tmpSSOCounter2)) : 0;
        // this.CTreq2 = !isNaN(Math.round(100 * (_tmpCTreq2 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTreq2 / _tmpSSOCounter2)) : 0;
        // this.CTreq3 = !isNaN(Math.round(100 * (_tmpCTreq3 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTreq3 / _tmpSSOCounter2)) : 0;
        // this.CTreq4 = !isNaN(Math.round(100 * (_tmpCTreq4 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTreq4 / _tmpSSOCounter2)) : 0;
        
        // this.MBreq1 = !isNaN(Math.round(100 * (_tmpMBreq1 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBreq1 / _tmpSSOCounter2)) : 0;
        // this.MBreq2 = !isNaN(Math.round(100 * (_tmpMBreq2 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBreq2 / _tmpSSOCounter2)) : 0;
        // this.MBreq3 = !isNaN(Math.round(100 * (_tmpMBreq3 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBreq3 / _tmpSSOCounter2)) : 0;
        // this.MBreq4 = !isNaN(Math.round(100 * (_tmpMBreq4 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBreq4 / _tmpSSOCounter2)) : 0;

        // this.CTact1 = !isNaN(Math.round(100 * (_tmpCTact1 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTact1 / _tmpSSOCounter2)) : 0;
        // this.CTact2 = !isNaN(Math.round(100 * (_tmpCTact2 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTact2 / _tmpSSOCounter2)) : 0;
        // this.CTact3 = !isNaN(Math.round(100 * (_tmpCTact3 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTact3 / _tmpSSOCounter2)) : 0;
        // this.CTact4 = !isNaN(Math.round(100 * (_tmpCTact4 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpCTact4 / _tmpSSOCounter2)) : 0;
        
        // this.MBact1 = !isNaN(Math.round(100 * (_tmpMBact1 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBact1 / _tmpSSOCounter2)) : 0;
        // this.MBact2 = !isNaN(Math.round(100 * (_tmpMBact2 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBact2 / _tmpSSOCounter2)) : 0;
        // this.MBact3 = !isNaN(Math.round(100 * (_tmpMBact3 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBact3 / _tmpSSOCounter2)) : 0;
        // this.MBact4 = !isNaN(Math.round(100 * (_tmpMBact4 / _tmpSSOCounter2))) ? Math.round(100 * (_tmpMBact4 / _tmpSSOCounter2)) : 0;
        
        this.isDataViewUpdated2 = true;
        setTimeout(() => {
          this.isDataViewUpdated2 = false;
        }, 1000);
      }

      filterRowsLogic3(){
 
        let _tmpSOCounter3: number = 0;
        let _tmpSSOCounter3: number = 0; 

        let _tmpCT1: number = 0;
        let _tmpCT2: number = 0;
        let _tmpCT3: number = 0;
        let _tmpCT4: number = 0;

        let _showSOWithNoSSO3:boolean = this.displaySOwithNoSSO3();
  
    
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO3: SalesOrder = this._soObjList2[i];  
          
          let _isSOPassedFilter3:boolean = true;
          if(_isSOPassedFilter3 == true){
            var _filteredSSO3:Array<SubSalesOrder> = this.getFilteredSubOrders3(_tmpSO3.subSalesOrder);
  
            if(_filteredSSO3.length > 0 || (_tmpSO3.subSalesOrder.length == 0 && _showSOWithNoSSO3 == true)){
            
               _tmpSOCounter3++;
              
              // let _tmpUISSoEqObj2:UiWaitReadySO;
                           
              _filteredSSO3.forEach((_tmpSSO3:SubSalesOrder) => {


                //// CT STAGGERED DELIVERY REPORT

                if(_tmpSSO3.purchaseMatReceipt.ctPTActualReceiptDate != null){
                  if(_tmpSSO3.purchaseMatReceipt.ctPTActualReceiptFirstDate != null){
                    
                  let _d =_tmpSSO3.purchaseMatReceipt.ctPTActualReceiptDate.getTime() - _tmpSSO3.purchaseMatReceipt.ctPTActualReceiptFirstDate.getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);

                  let _caseDays: number = 0;
                  if (_daysDiff >= 0 && _daysDiff <= 5) {
                    _caseDays = 1;
                  }
                  else if (_daysDiff > 5 && _daysDiff <= 10) {
                    _caseDays = 2;
                  }
                  else if (_daysDiff > 10) {
                    _caseDays = 3;
                  } 
                  switch(_caseDays){
                    case 1 : _tmpCT1++;
                      break;
                      case 2 : _tmpCT2++;
                      break;
                      case 3 : _tmpCT3++;
                      break;
                      

                  }

                  }
                  else{
                    _tmpCT4++;
                  }
                  _tmpSSOCounter3++;
                  
                }


              });
                  // _tmpSSOCounter3++;

            }
           
         
          }
         
        } 
       

        this.filteredSOCount3 = _tmpSOCounter3;
        this.filteredSSOCount3 = _tmpSSOCounter3;
   

        this.CT1 = _tmpCT1;
        this.CT2 = _tmpCT2;
        this.CT3 = _tmpCT3;
        this.CT4 = _tmpCT4;
        let _tempCT = _tmpCT1 + _tmpCT2 + _tmpCT3 + _tmpCT4;
        
        if(_tempCT!=0){
          this.data3 = [{
            "data": [
              {
                name: '0 - 5 days',
                y: _tmpCT1,
                color: '#ff000f'
                
              },
              {
                name: '5 - 10 days',
                y: _tmpCT2,
                color: '#262626'
                

              },
              {
                name: '> 10 days',
                y: _tmpCT3,
                color: '#6e6e6e'
                
              
              },
              {
                name: 'Other',
                y: _tmpCT4,
                color: '#a9a9a9'
                
              }
            ]
          }
                     
                  
         ];
        }
        else this.data3= null;
      //   this.data3 = [{
      //     "data":[
      //       ['0 - 5 days',  _tmpCT1],
      //       ['5 -10 days',       _tmpCT2],
      //       {
      //          name: '> 10 days',
      //          y: _tmpCT3,
      //          sliced: true,
      //          selected: true
      //       },
      //       ['Other',    _tmpCT4],
      //     ]
      //   }
      //  ];
      this.kpiChartOptions3 = this._kpiCharServ.getChartOptions(this,this.data3);  
      // this.drawHighchart = true;
  
     
        this.isDataViewUpdated2 = true;
        setTimeout(() => {
          this.isDataViewUpdated2 = false;
        }, 1000);
      }

      filterRowsLogic4(){
      
        let _tmpSOCounter4: number = 0;
        let _tmpSSOCounter4: number = 0; 

        let _tmpBrkrMch1: number = 0;
        let _tmpBrkrMch2: number = 0;
        let _tmpBrkrMch3: number = 0;
        let _tmpBrkrMch4: number = 0;


        let _showSOWithNoSSO4:boolean = this.displaySOwithNoSSO4();
  
    
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO4: SalesOrder = this._soObjList2[i];  
          
          let _isSOPassedFilter4:boolean = true;
          if(_isSOPassedFilter4 == true){
            var _filteredSSO4:Array<SubSalesOrder> = this.getFilteredSubOrders4(_tmpSO4.subSalesOrder);
  
            if(_filteredSSO4.length > 0 || (_tmpSO4.subSalesOrder.length == 0 && _showSOWithNoSSO4 == true)){
            
               _tmpSOCounter4++;
              
                           
              _filteredSSO4.forEach((_tmpSSO4:SubSalesOrder) => {

              
               //// BREAKER RECEIPT MONITORING REPORT

               if(_tmpSSO4.purchaseMatReceipt.breakerActualReceiptDate != null && _tmpSSO4.productionIP.mechanicalStickerActualDate  != null){
                 
                let _d =_tmpSSO4.purchaseMatReceipt.breakerActualReceiptDate.getTime() - _tmpSSO4.productionIP.mechanicalStickerActualDate.getTime()
                let _daysDiff = _d / (1000 * 3600 * 24);

                let _caseDays: number = 0;
                if (_daysDiff <= -5) {
                  _caseDays = 1;
                }
                else if (_daysDiff > -5 && _daysDiff <= -3) {
                  _caseDays = 2;
                }
                else if (_daysDiff > -2 && _daysDiff <= 2) {
                  _caseDays = 3;
                }else if (_daysDiff > 3) {
                  _caseDays = 4;
                } 
                switch(_caseDays){
                  case 1 : _tmpBrkrMch1++;
                    break;
                    case 2 : _tmpBrkrMch2++;
                    break;
                    case 3 : _tmpBrkrMch3++;
                    break;
                    case 4 : _tmpBrkrMch4++;
                    break;
                    

                }
                _tmpSSOCounter4++;
              }

              });
                  // _tmpSSOCounter4++;

            }
           
          }
         
        } 
       
            
        this.filteredSOCount4 = _tmpSOCounter4;
        this.filteredSSOCount4 = _tmpSSOCounter4;
   

        this.BrkrMch1 = _tmpBrkrMch1;
        this.BrkrMch2 = _tmpBrkrMch2;
        this.BrkrMch3 = _tmpBrkrMch3;
        this.BrkrMch4 = _tmpBrkrMch4;

               
        let _tempBrkMch = _tmpBrkrMch1 + _tmpBrkrMch2 + _tmpBrkrMch3 + _tmpBrkrMch4
        if(_tempBrkMch!=0){
          this.data4 = [{
            "data":[
              {
                name: '< (-5 days)',
                y: _tmpBrkrMch1,
                color: '#ff000f'
              },
              {
                name: '-3 to -5 days',
                y: _tmpBrkrMch2,
                color: '#262626'
              },
              {
                name: '-2 to 2 days',
                y: _tmpBrkrMch3,
               color: '#6e6e6e'
              },
              {
                name: '> 3 days',
                y: _tmpBrkrMch4,
                 color: '#a9a9a9'
              }
            ]
          }
                     
                  
         ];
        }
        else this.data4= null;

      this.kpiChartOptions4 = this._kpiCharServ.getPieChartOptions(this,this.data4);  
      // this.drawHighchart = true;
  
       
        this.isDataViewUpdated2 = true;
        setTimeout(() => {
          this.isDataViewUpdated2 = false;
        }, 1000);
      }

      filterRowsLogic5(){
    
        let _tmpSOCounter5: number = 0;
        let _tmpSSOCounter5: number = 0; 
        let _tmpSSOCounter5a: number = 0; 

        let _tmpCTreq1: number = 0;
        let _tmpCTreq2: number = 0;
        let _tmpCTreq3: number = 0;
        let _tmpCTreq4: number = 0;

        let _tmpMBreq1: number = 0;
        let _tmpMBreq2: number = 0;
        let _tmpMBreq3: number = 0;
        let _tmpMBreq4: number = 0;

        let _showSOWithNoSSO5:boolean = this.displaySOwithNoSSO5();
  
    
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO5: SalesOrder = this._soObjList2[i];  
          
          let _isSOPassedFilter5:boolean = true;
          if(_isSOPassedFilter5 == true){
            var _filteredSSO5:Array<SubSalesOrder> = this.getFilteredSubOrders5(_tmpSO5.subSalesOrder);
  
            if(_filteredSSO5.length > 0 || (_tmpSO5.subSalesOrder.length == 0 && _showSOWithNoSSO5 == true)){
            
               _tmpSOCounter5++;
              
                           
              _filteredSSO5.forEach((_tmpSSO5:SubSalesOrder) => {

                //// CT & MB WRT REQUESTED LINE LOADING REPORT

                if(_tmpSSO5.purchaseMatReceipt.ctPTActualReceiptDate != null && _tmpSSO5.planningIP.requestedLineLoadingDate != null){
                    // && _tmpSSO5.productionIP.lineLoadingActualDate == null ){
                 
                  let _d =_tmpSSO5.purchaseMatReceipt.ctPTActualReceiptDate.getTime() - _tmpSSO5.planningIP.requestedLineLoadingDate.getTime()
                  let _daysDiff = _d / (1000 * 3600 * 24);
                    
                  let _caseDays: number = 0;
                  if (_daysDiff < -5) {
                    _caseDays = 1;
                  }
                  else if (_daysDiff > -5 && _daysDiff <= -4) {
                    _caseDays = 2;
                  }
                  else if (_daysDiff == -3 ) {
                    _caseDays = 3;
                  }else if (_daysDiff > 0) {
                    _caseDays = 4;
                  } 
                  switch(_caseDays){
                    case 1 : _tmpCTreq1++;
                      break;
                      case 2 : _tmpCTreq2++;
                      break;
                      case 3 : _tmpCTreq3++;
                      break;
                      case 4 : _tmpCTreq4++;
                      break;
                      
  
                  }
                  _tmpSSOCounter5++;
                }
                if(_tmpSSO5.purchaseMatReceipt.meteringBoxActualReceiptDate != null && _tmpSSO5.planningIP.requestedLineLoadingDate != null){
                  let _d1 =_tmpSSO5.purchaseMatReceipt.meteringBoxActualReceiptDate.getTime() - _tmpSSO5.planningIP.requestedLineLoadingDate.getTime()
                  let _daysDiff1 = _d1 / (1000 * 3600 * 24);
  
                  let _caseDays1: number = 0;
                  if (_daysDiff1 < -5) {
                    _caseDays1 = 1;
                  }
                  else if (_daysDiff1 > -5 && _daysDiff1 <= -4) {
                    _caseDays1 = 2;
                  }
                  else if (_daysDiff1 == -3 ) {
                    _caseDays1 = 3;
                  }else if (_daysDiff1 > 0) {
                    _caseDays1 = 4;
                  } 
                  switch(_caseDays1){
                    case 1 : _tmpMBreq1++;
                      break;
                      case 2 : _tmpMBreq2++;
                      break;
                      case 3 : _tmpMBreq3++;
                      break;
                      case 4 : _tmpMBreq4++;
                      break;
                      
  
                  }
                  _tmpSSOCounter5a++;
                }


              });
                  // _tmpSSOCounter5++;

            }
           
         
          }
         
        } 
        
        this.filteredSOCount5 = _tmpSOCounter5;
        this.filteredSSOCount5 = _tmpSSOCounter5;
        this.filteredSSOCount5a = _tmpSSOCounter5a;

        this.CTreq1 = _tmpCTreq1;
        this.CTreq2 = _tmpCTreq2;
        this.CTreq3 = _tmpCTreq3;
        this.CTreq4 = _tmpCTreq4;

        this.MBreq1 = _tmpMBreq1;
        this.MBreq2 = _tmpMBreq2;
        this.MBreq3 = _tmpMBreq3;
        this.MBreq4 = _tmpMBreq4;

        let _tempCTMB1 = _tmpCTreq1 + _tmpCTreq2 + _tmpCTreq3 + _tmpCTreq4 
        let _tempCTMB1a = _tmpMBreq1 + _tmpMBreq2 + _tmpMBreq3 + _tmpMBreq4
        if(_tempCTMB1!=0){
          this.data5 = [{
            "data":[
              {
                name: '< (-5 days)',
                y:  _tmpCTreq1 ,
                 color: '#ff000f'
              },
              {
                name: '-4 to -5 days',
                y: _tmpCTreq2,
                color: '#262626'
              },
              {
                name: '-3 days',
                y: _tmpCTreq3,
               color: '#6e6e6e'
              },
              {
                name: '> 0 days',
                y: _tmpCTreq4,
               color: '#a9a9a9'
              }
            ]
          }
                     
                  
         ];
        }
        else this.data5= null;


        if(_tempCTMB1a!=0){
          this.data5a = [{
            "data":[
              {
                name: '< (-5 days)',
                y:  _tmpMBreq1 ,
                color: '#ff000f'
              },
              {
                name: '-4 to -5 days',
                y: _tmpMBreq2,
                color: '#262626'
              },
              {
                name: '-3 days',
                y: _tmpMBreq3,
               color: '#6e6e6e'
              },
              {
                name: '> 0 days',
                y: _tmpMBreq4,
                 color: '#a9a9a9'
              }
            ]
          }
                     
                  
         ];
        }
        else this.data5a= null;

      this.kpiChartOptions5 = this._kpiCharServ.getPieChartOptions2(this,this.data5,1);  
      this.kpiChartOptions5a = this._kpiCharServ.getPieChartOptions2(this,this.data5a,2);  
      // this.drawHighchart = true;
  
        this.isDataViewUpdated2 = true;
        setTimeout(() => {
          this.isDataViewUpdated2 = false;
        }, 1000);
      }

      filterRowsLogic6(){
    
        let _tmpSOCounter6: number = 0;
        let _tmpSSOCounter6: number = 0; 
        let _tmpSSOCounter6a: number = 0; 

        let _tmpCTact1: number = 0;
        let _tmpCTact2: number = 0;
        let _tmpCTact3: number = 0;
        let _tmpCTact4: number = 0;

        let _tmpMBact1: number = 0;
        let _tmpMBact2: number = 0;
        let _tmpMBact3: number = 0;
        let _tmpMBact4: number = 0;


        let _showSOWithNoSSO6:boolean = this.displaySOwithNoSSO6();
  
    
        for (var i = 0; i < this._soObjList2.length; i++) {
          let _tmpSO6: SalesOrder = this._soObjList2[i];  
          
          let _isSOPassedFilter6:boolean = true;
          if(_isSOPassedFilter6 == true){
            var _filteredSSO6:Array<SubSalesOrder> = this.getFilteredSubOrders6(_tmpSO6.subSalesOrder);
  
            if(_filteredSSO6.length > 0 || (_tmpSO6.subSalesOrder.length == 0 && _showSOWithNoSSO6 == true)){
            
               _tmpSOCounter6++;
              
                           
              _filteredSSO6.forEach((_tmpSSO6:SubSalesOrder) => {

                 //// CT & MB WRT ACTUAL LINE LOADING REPORT

                 if(_tmpSSO6.purchaseMatReceipt.ctPTActualReceiptDate != null && _tmpSSO6.productionIP.lineLoadingActualDate != null ){
                
                 let _d =_tmpSSO6.purchaseMatReceipt.ctPTActualReceiptDate.getTime() - _tmpSSO6.productionIP.lineLoadingActualDate.getTime()
                 let _daysDiff = _d / (1000 * 3600 * 24);
                   
                 let _caseDays: number = 0;
                 if (_daysDiff < -5) {
                   _caseDays = 1;
                 }
                 else if (_daysDiff > -5 && _daysDiff <= -4) {
                   _caseDays = 2;
                 }
                 else if (_daysDiff == -3 ) {
                   _caseDays = 3;
                 }else if (_daysDiff > 0) {
                   _caseDays = 4;
                 } 
                 switch(_caseDays){
                   case 1 : _tmpCTact1++;
                     break;
                     case 2 : _tmpCTact2++;
                     break;
                     case 3 : _tmpCTact3++;
                     break;
                     case 4 : _tmpCTact4++;
                     break;
                     
 
                 }
                 _tmpSSOCounter6++;
                }

                if(_tmpSSO6.purchaseMatReceipt.meteringBoxActualReceiptDate != null && _tmpSSO6.productionIP.lineLoadingActualDate != null ){
                
                 let _d1 =_tmpSSO6.purchaseMatReceipt.meteringBoxActualReceiptDate.getTime() - _tmpSSO6.productionIP.lineLoadingActualDate.getTime()
                 let _daysDiff1 = _d1 / (1000 * 3600 * 24);
 
                 let _caseDays1: number = 0;
                 if (_daysDiff1 < -5) {
                   _caseDays1 = 1;
                 }
                 else if (_daysDiff1 > -5 && _daysDiff1 <= -4) {
                   _caseDays1 = 2;
                 }
                 else if (_daysDiff1 == -3 ) {
                   _caseDays1 = 3;
                 }else if (_daysDiff1 > 0) {
                   _caseDays1 = 4;
                 } 
                 switch(_caseDays1){
                   case 1 : _tmpMBact1++;
                     break;
                     case 2 : _tmpMBact2++;
                     break;
                     case 3 : _tmpMBact3++;
                     break;
                     case 4 : _tmpMBact4++;
                     break;
                     
 
                 }
                 _tmpSSOCounter6a++; 
               }

              });
                  // _tmpSSOCounter6++;

            }
         
          }
         
        } 
 
        
        this.filteredSOCount6 = _tmpSOCounter6;
        this.filteredSSOCount6 = _tmpSSOCounter6;
        this.filteredSSOCount6a = _tmpSSOCounter6a;


        this.CTact1 = _tmpCTact1;
        this.CTact2 = _tmpCTact2;
        this.CTact3 = _tmpCTact3;
        this.CTact4 = _tmpCTact4;

        this.MBact1 = _tmpMBact1;
        this.MBact2 = _tmpMBact2;
        this.MBact3 = _tmpMBact3;
        this.MBact4 = _tmpMBact4;

        let _tempCTMB2 = _tmpCTact1 + _tmpCTact2 + _tmpCTact3 + _tmpCTact4 ;
        let _tempCTMB2a = _tmpMBact1 + _tmpMBact2 + _tmpMBact3 + _tmpMBact4;
       
        if(_tempCTMB2!=0){
          this.data6 = [{
            "data":[
              {
                name: '< (-5 days)',
                y:  _tmpCTact1 ,
                color: '#ff000f'
              },
              {
                name: '-4 to -5 days',
                y: _tmpCTact2,
                color: '#262626'
              },
              {
                name: '-3 days',
                y: _tmpCTact3,
                color: '#6e6e6e'
              },
              {
                name: '> 0 days',
                y: _tmpCTact4,
                color: '#a9a9a9'
              }
            ]
          }
                     
                  
         ];
        }
        else this.data6= null;

        if(_tempCTMB2a!=0){
          this.data6a = [{
            "data":[
              {
                name: '< (-5 days)',
                y:  _tmpMBact1 ,
                 color: '#ff000f'
              },
              {
                name: '-4 to -5 days',
                y: _tmpMBact2,
               color: '#262626'
              },
              {
                name: '-3 days',
                y: _tmpMBact3,
                color: '#6e6e6e'
              },
              {
                name: '> 0 days',
                y: _tmpMBact4,
                color: '#a9a9a9'
              }
            ]
          }
                     
                  
         ];
        }
        else this.data6a = null;

      this.kpiChartOptions6 = this._kpiCharServ.getPieChartOptions2(this,this.data6,3);  
      this.kpiChartOptions6a = this._kpiCharServ.getPieChartOptions2(this,this.data6a,4);  
      // this.drawHighchart = true;

        this.isDataViewUpdated2 = true;
        setTimeout(() => {
          this.isDataViewUpdated2 = false;
        }, 1000);
      }
      formatProductName(_fullProductName:string){
        if(_fullProductName.startsWith('UG ') == true){
          return _fullProductName.substring(3);
        }
        else if(_fullProductName.startsWith('LG ') == true){
          return _fullProductName.substring(3);
        }
        return _fullProductName;
      }

    
      getRevMonthLabel():string{
        if(this.isRevMonthFilterSelected2 == true){
          return "Revenue Month : ";
        }
        else{
          return "Enable Revenue Month Filter";
        }
      }
      getInvMonthLabel():string{
        if(this.isInvMonthFilterSelected2 == true){
          return "Invoicing Month : ";
        }
        else{
          return "Enable Invoicing Month Filter";
        }
      }
      getManfMonthLabel():string{
        if(this.isManfMonthFilterSelected2 == true){
          return "Manufacturing Month : ";
        }
        else{
          return "Enable Manufacturing Month Filter";
        }
      }
//
      getRevMonthLabel3():string{
        if(this.isRevMonthFilterSelected3 == true){
          return "Revenue Month : ";
        }
        else{
          return "Enable Revenue Month Filter";
        }
      }
      getInvMonthLabel3():string{
        if(this.isInvMonthFilterSelected3 == true){
          return "Invoicing Month : ";
        }
        else{
          return "Enable Invoicing Month Filter";
        }
      }
      getManfMonthLabel3():string{
        if(this.isManfMonthFilterSelected3 == true){
          return "Manufacturing Month : ";
        }
        else{
          return "Enable Manufacturing Month Filter";
        }
      }
//
      getRevMonthLabel4():string{
        if(this.isRevMonthFilterSelected4 == true){
          return "Revenue Month : ";
        }
        else{
          return "Enable Revenue Month Filter";
        }
      }
      getInvMonthLabel4():string{
        if(this.isInvMonthFilterSelected4 == true){
          return "Invoicing Month : ";
        }
        else{
          return "Enable Invoicing Month Filter";
        }
      }
      getManfMonthLabel4():string{
        if(this.isManfMonthFilterSelected4 == true){
          return "Manufacturing Month : ";
        }
        else{
          return "Enable Manufacturing Month Filter";
        }
      }
//
     
      getRevMonthLabel5():string{
        if(this.isRevMonthFilterSelected5 == true){
          return "Revenue Month : ";
        }
        else{
          return "Enable Revenue Month Filter";
        }
      }
      getInvMonthLabel5():string{
        if(this.isInvMonthFilterSelected5 == true){
          return "Invoicing Month : ";
        }
        else{
          return "Enable Invoicing Month Filter";
        }
      }
      getManfMonthLabel5():string{
        if(this.isManfMonthFilterSelected5 == true){
          return "Manufacturing Month : ";
        }
        else{
          return "Enable Manufacturing Month Filter";
        }
      }
//
      getRevMonthLabel6():string{
        if(this.isRevMonthFilterSelected6 == true){
          return "Revenue Month : ";
        }
        else{
          return "Enable Revenue Month Filter";
        }
      }
      getInvMonthLabel6():string{
        if(this.isInvMonthFilterSelected6 == true){
          return "Invoicing Month : ";
        }
        else{
          return "Enable Invoicing Month Filter";
        }
      }
      getManfMonthLabel6():string{
        if(this.isManfMonthFilterSelected6 == true){
          return "Manufacturing Month : ";
        }
        else{
          return "Enable Manufacturing Month Filter";
        }
      }
  

      getRevFromMonthName():string{
        if(this.revMonthFilter2){
          return this.revMonthFilter2.fromMonthName;
        }
        return '';
      }
      getRevToMonthName():string{
        if(this.revMonthFilter2){
          return this.revMonthFilter2.toMonthName;
        }
        return '';
      }
      getInvFromMonthName():string{
        if(this.InvMonthFilter2){
          return this.InvMonthFilter2.fromMonthName;
        }
        return '';
      }
      getInvToMonthName():string{
        if(this.InvMonthFilter2){
          return this.InvMonthFilter2.toMonthName;
        }
        return '';
      }
     
      
      getManfFromMonthName():string{
        if(this.manfMonthFilter2){
          return this.manfMonthFilter2.fromMonthName;
        }
        return '';
      }
      getManfToMonthName():string{
        if(this.manfMonthFilter2){
          return this.manfMonthFilter2.toMonthName;
        }
        return '';
      }
      ///
      getRevFromMonthName3():string{
        if(this.revMonthFilter3){
          return this.revMonthFilter3.fromMonthName;
        }
        return '';
      }
      getRevToMonthName3():string{
        if(this.revMonthFilter3){
          return this.revMonthFilter3.toMonthName;
        }
        return '';
      }
      getInvFromMonthName3():string{
        if(this.InvMonthFilter3){
          return this.InvMonthFilter3.fromMonthName;
        }
        return '';
      }
      getInvToMonthName3():string{
        if(this.InvMonthFilter3){
          return this.InvMonthFilter3.toMonthName;
        }
        return '';
      }
     
      
      getManfFromMonthName3():string{
        if(this.manfMonthFilter3){
          return this.manfMonthFilter3.fromMonthName;
        }
        return '';
      }
      getManfToMonthName3():string{
        if(this.manfMonthFilter3){
          return this.manfMonthFilter3.toMonthName;
        }
        return '';
      }
      ///
      getRevFromMonthName4():string{
        if(this.revMonthFilter4){
          return this.revMonthFilter4.fromMonthName;
        }
        return '';
      }
      getRevToMonthName4():string{
        if(this.revMonthFilter4){
          return this.revMonthFilter4.toMonthName;
        }
        return '';
      }
      getInvFromMonthName4():string{
        if(this.InvMonthFilter4){
          return this.InvMonthFilter4.fromMonthName;
        }
        return '';
      }
      getInvToMonthName4():string{
        if(this.InvMonthFilter4){
          return this.InvMonthFilter4.toMonthName;
        }
        return '';
      }
     
      
      getManfFromMonthName4():string{
        if(this.manfMonthFilter4){
          return this.manfMonthFilter4.fromMonthName;
        }
        return '';
      }
      getManfToMonthName4():string{
        if(this.manfMonthFilter4){
          return this.manfMonthFilter4.toMonthName;
        }
        return '';
      }
      ////
      getRevFromMonthName5():string{
        if(this.revMonthFilter5){
          return this.revMonthFilter5.fromMonthName;
        }
        return '';
      }
      getRevToMonthName5():string{
        if(this.revMonthFilter5){
          return this.revMonthFilter5.toMonthName;
        }
        return '';
      }
      getInvFromMonthName5():string{
        if(this.InvMonthFilter5){
          return this.InvMonthFilter5.fromMonthName;
        }
        return '';
      }
      getInvToMonthName5():string{
        if(this.InvMonthFilter5){
          return this.InvMonthFilter5.toMonthName;
        }
        return '';
      }
     
      
      getManfFromMonthName5():string{
        if(this.manfMonthFilter5){
          return this.manfMonthFilter5.fromMonthName;
        }
        return '';
      }
      getManfToMonthName5():string{
        if(this.manfMonthFilter5){
          return this.manfMonthFilter5.toMonthName;
        }
        return '';
      }
      /////
      getRevFromMonthName6():string{
        if(this.revMonthFilter6){
          return this.revMonthFilter6.fromMonthName;
        }
        return '';
      }
      getRevToMonthName6():string{
        if(this.revMonthFilter6){
          return this.revMonthFilter6.toMonthName;
        }
        return '';
      }
      getInvFromMonthName6():string{
        if(this.InvMonthFilter6){
          return this.InvMonthFilter6.fromMonthName;
        }
        return '';
      }
      getInvToMonthName6():string{
        if(this.InvMonthFilter6){
          return this.InvMonthFilter6.toMonthName;
        }
        return '';
      }
     
      
      getManfFromMonthName6():string{
        if(this.manfMonthFilter6){
          return this.manfMonthFilter6.fromMonthName;
        }
        return '';
      }
      getManfToMonthName6():string{
        if(this.manfMonthFilter6){
          return this.manfMonthFilter6.toMonthName;
        }
        return '';
      }

      InvPrevFromMonth(){
        this.InvMonthFilter2.prevFromMonth();
        this.filterRows();
      }
      InvNextFromMonth(){
        this.InvMonthFilter2.nextFromMonth();
        this.filterRows();
      }
      InvPrevToMonth(){
        this.InvMonthFilter2.prevToMonth();
        this.filterRows();
      }
      InvNextToMonth(){
        this.InvMonthFilter2.nextToMonth();
        this.filterRows();
      }
     
      revPrevFromMonth(){
        this.revMonthFilter2.prevFromMonth();
        this.filterRows();
      }
      revNextFromMonth(){
        this.revMonthFilter2.nextFromMonth();
        this.filterRows();
      }
      revPrevToMonth(){
        this.revMonthFilter2.prevToMonth();
        this.filterRows();
      }
      revNextToMonth(){
        this.revMonthFilter2.nextToMonth();
        this.filterRows();
      }
    
      manfPrevFromMonth(){
        this.manfMonthFilter2.prevFromMonth();
        this.filterRows();
      }
      manfNextFromMonth(){
        this.manfMonthFilter2.nextFromMonth();
        this.filterRows();
      }
      manfPrevToMonth(){
        this.manfMonthFilter2.prevToMonth();
        this.filterRows();
      }
      manfNextToMonth(){
        this.manfMonthFilter2.nextToMonth();
        this.filterRows();
      }

      //
      revPrevFromMonth3(){
        this.revMonthFilter3.prevFromMonth();
        this.filterRows3();
      }
      revNextFromMonth3(){
        this.revMonthFilter3.nextFromMonth();
        this.filterRows3();
      }
      revPrevToMonth3(){
        this.revMonthFilter3.prevToMonth();
        this.filterRows3();
      }
      revNextToMonth3(){
        this.revMonthFilter3.nextToMonth();
        this.filterRows3();
      }
    
      manfPrevFromMonth3(){
        this.manfMonthFilter3.prevFromMonth();
        this.filterRows3();
      }
      manfNextFromMonth3(){
        this.manfMonthFilter3.nextFromMonth();
        this.filterRows3();
      }
      manfPrevToMonth3(){
        this.manfMonthFilter3.prevToMonth();
        this.filterRows3();
      }
      manfNextToMonth3(){
        this.manfMonthFilter3.nextToMonth();
        this.filterRows3();
      }
      InvPrevFromMonth3(){
        this.InvMonthFilter3.prevFromMonth();
        this.filterRows3();
      }
      InvNextFromMonth3(){
        this.InvMonthFilter3.nextFromMonth();
        this.filterRows3();
      }
      InvPrevToMonth3(){
        this.InvMonthFilter3.prevToMonth();
        this.filterRows3();
      }
      InvNextToMonth3(){
        this.InvMonthFilter3.nextToMonth();
        this.filterRows3();
      }
    ///
    revPrevFromMonth4(){
      this.revMonthFilter4.prevFromMonth();
      this.filterRows4();
    }
    revNextFromMonth4(){
      this.revMonthFilter4.nextFromMonth();
      this.filterRows4();
    }
    revPrevToMonth4(){
      this.revMonthFilter4.prevToMonth();
      this.filterRows4();
    }
    revNextToMonth4(){
      this.revMonthFilter4.nextToMonth();
      this.filterRows4();
    }
  
    manfPrevFromMonth4(){
      this.manfMonthFilter4.prevFromMonth();
      this.filterRows4();
    }
    manfNextFromMonth4(){
      this.manfMonthFilter4.nextFromMonth();
      this.filterRows4();
    }
    manfPrevToMonth4(){
      this.manfMonthFilter4.prevToMonth();
      this.filterRows4();
    }
    manfNextToMonth4(){
      this.manfMonthFilter4.nextToMonth();
      this.filterRows4();
    }
    InvPrevFromMonth4(){
      this.InvMonthFilter4.prevFromMonth();
       this.filterRows4();
    }
    InvNextFromMonth4(){
      this.InvMonthFilter4.nextFromMonth();
       this.filterRows4();
    }
    InvPrevToMonth4(){
      this.InvMonthFilter4.prevToMonth();
       this.filterRows4();
    }
    InvNextToMonth4(){
      this.InvMonthFilter4.nextToMonth();
       this.filterRows4();
    }
    /////
    revPrevFromMonth5(){
      this.revMonthFilter5.prevFromMonth();
      this.filterRows5();
    }
    revNextFromMonth5(){
      this.revMonthFilter5.nextFromMonth();
      this.filterRows5();
    }
    revPrevToMonth5(){
      this.revMonthFilter5.prevToMonth();
      this.filterRows5();
    }
    revNextToMonth5(){
      this.revMonthFilter5.nextToMonth();
      this.filterRows5();
    }
  
    manfPrevFromMonth5(){
      this.manfMonthFilter5.prevFromMonth();
      this.filterRows5();
    }
    manfNextFromMonth5(){
      this.manfMonthFilter5.nextFromMonth();
      this.filterRows5();
    }
    manfPrevToMonth5(){
      this.manfMonthFilter5.prevToMonth();
      this.filterRows5();
    }
    manfNextToMonth5(){
      this.manfMonthFilter5.nextToMonth();
      this.filterRows5();
    }
    InvPrevFromMonth5(){
      this.InvMonthFilter5.prevFromMonth();
      this.filterRows5();
    }
    InvNextFromMonth5(){
      this.InvMonthFilter5.nextFromMonth();
      this.filterRows5();
    }
    InvPrevToMonth5(){
      this.InvMonthFilter5.prevToMonth();
      this.filterRows5();
    }
    InvNextToMonth5(){
      this.InvMonthFilter5.nextToMonth();
      this.filterRows5();
    }
    /////
    revPrevFromMonth6(){
      this.revMonthFilter6.prevFromMonth();
      this.filterRows6();
    }
    revNextFromMonth6(){
      this.revMonthFilter6.nextFromMonth();
      this.filterRows6();
    }
    revPrevToMonth6(){
      this.revMonthFilter6.prevToMonth();
      this.filterRows6();
    }
    revNextToMonth6(){
      this.revMonthFilter6.nextToMonth();
      this.filterRows6();
    }
  
    manfPrevFromMonth6(){
      this.manfMonthFilter6.prevFromMonth();
      this.filterRows6();
    }
    manfNextFromMonth6(){
      this.manfMonthFilter6.nextFromMonth();
      this.filterRows6();
    }
    manfPrevToMonth6(){
      this.manfMonthFilter6.prevToMonth();
      this.filterRows6();
    }
    manfNextToMonth6(){
      this.manfMonthFilter6.nextToMonth();
      this.filterRows6();
    }
    InvPrevFromMonth6(){
      this.InvMonthFilter6.prevFromMonth();
      this.filterRows6();
    }
    InvNextFromMonth6(){
      this.InvMonthFilter6.nextFromMonth();
      this.filterRows6();
    }
    InvPrevToMonth6(){
      this.InvMonthFilter6.prevToMonth();
      this.filterRows6();
    }
    InvNextToMonth6(){
      this.InvMonthFilter6.nextToMonth();
      this.filterRows6();
    }
  
     
     
      private getFilteredSubOrders(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
        return _ssoAr.filter((_sso:SubSalesOrder) => {
          //check for failure cases
          //dont show if sub order is dispatched
          if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
    
          //check if revenue month 
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;

          if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected2,this.revMonthFilter2) == false) return false;
          if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected2,this.InvMonthFilter2) == false) return false;
          if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected2,this.manfMonthFilter2) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected3,this.revMonthFilter3) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected3,this.InvMonthFilter3) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected3,this.manfMonthFilter3) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected4,this.revMonthFilter4) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected4,this.InvMonthFilter4) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected4,this.manfMonthFilter4) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected5,this.revMonthFilter5) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected5,this.InvMonthFilter5) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected5,this.manfMonthFilter5) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected6,this.revMonthFilter6) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected6,this.InvMonthFilter6) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected6,this.manfMonthFilter6) == false) return false;
        
          return true;
        });
      }

      private getFilteredSubOrders3(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
        return _ssoAr.filter((_sso:SubSalesOrder) => {
          //check for failure cases
          //dont show if sub order is dispatched
          if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
    
          //check if revenue month 
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;

          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected2,this.revMonthFilter2) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected2,this.InvMonthFilter2) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected2,this.manfMonthFilter2) == false) return false;
        
          if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected3,this.revMonthFilter3) == false) return false;
          if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected3,this.InvMonthFilter3) == false) return false;
          if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected3,this.manfMonthFilter3) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected4,this.revMonthFilter4) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected4,this.InvMonthFilter4) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected4,this.manfMonthFilter4) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected5,this.revMonthFilter5) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected5,this.InvMonthFilter5) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected5,this.manfMonthFilter5) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected6,this.revMonthFilter6) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected6,this.InvMonthFilter6) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected6,this.manfMonthFilter6) == false) return false;
        
          return true;
        });
      }

      private getFilteredSubOrders4(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
        return _ssoAr.filter((_sso:SubSalesOrder) => {
          //check for failure cases
          //dont show if sub order is dispatched
          if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
    
          //check if revenue month 
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;

          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected2,this.revMonthFilter2) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected2,this.InvMonthFilter2) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected2,this.manfMonthFilter2) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected3,this.revMonthFilter3) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected3,this.InvMonthFilter3) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected3,this.manfMonthFilter3) == false) return false;
        
          if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected4,this.revMonthFilter4) == false) return false;
          if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected4,this.InvMonthFilter4) == false) return false;
          if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected4,this.manfMonthFilter4) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected5,this.revMonthFilter5) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected5,this.InvMonthFilter5) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected5,this.manfMonthFilter5) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected6,this.revMonthFilter6) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected6,this.InvMonthFilter6) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected6,this.manfMonthFilter6) == false) return false;
        
          return true;
        });
      }

      private getFilteredSubOrders5(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
        return _ssoAr.filter((_sso:SubSalesOrder) => {
          //check for failure cases
          //dont show if sub order is dispatched
          if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
    
          //check if revenue month 
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;

          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected2,this.revMonthFilter2) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected2,this.InvMonthFilter2) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected2,this.manfMonthFilter2) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected3,this.revMonthFilter3) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected3,this.InvMonthFilter3) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected3,this.manfMonthFilter3) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected4,this.revMonthFilter4) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected4,this.InvMonthFilter4) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected4,this.manfMonthFilter4) == false) return false;
        
          if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected5,this.revMonthFilter5) == false) return false;
          if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected5,this.InvMonthFilter5) == false) return false;
          if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected5,this.manfMonthFilter5) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected6,this.revMonthFilter6) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected6,this.InvMonthFilter6) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected6,this.manfMonthFilter6) == false) return false;
        
          return true;
        });
      }

      private getFilteredSubOrders6(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
        return _ssoAr.filter((_sso:SubSalesOrder) => {
          //check for failure cases
          //dont show if sub order is dispatched
          if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
    
          //check if revenue month 
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;

          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected2,this.revMonthFilter2) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected2,this.InvMonthFilter2) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected2,this.manfMonthFilter2) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected3,this.revMonthFilter3) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected3,this.InvMonthFilter3) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected3,this.manfMonthFilter3) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected4,this.revMonthFilter4) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected4,this.InvMonthFilter4) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected4,this.manfMonthFilter4) == false) return false;
        
          // if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected5,this.revMonthFilter5) == false) return false;
          // if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected5,this.InvMonthFilter5) == false) return false;
          // if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected5,this.manfMonthFilter5) == false) return false;
        
          if(this.isRevMonthFilterPassed(_sso.revenueMonth,this.isRevMonthFilterSelected6,this.revMonthFilter6) == false) return false;
          if(this.isInvMonthFilterPassed(_sso.invoicingmonth,this.isInvMonthFilterSelected6,this.InvMonthFilter6) == false) return false;
          if(this.isManfMonthFilterPassed(_sso.manufacturingMonth,this.isManfMonthFilterSelected6,this.manfMonthFilter6) == false) return false;
        
          return true;
        });
      }
  
  
   
      // private isRevMonthFilterPassed(_revenueMonth:Date){
      //   if(this.isRevMonthFilterSelected2 == true && this.revMonthFilter2 != null){
      //       if(this.revMonthFilter2.isWithInFilterScope(_revenueMonth) == false) {
      //         return false;
      //       }
      //   }
      //   return true;
      // }
      // private isInvMonthFilterPassed(_invoicingmonth:Date){
      //   if(this.isInvMonthFilterSelected2 == true && this.InvMonthFilter2 != null){
      //       if(this.InvMonthFilter2.isWithInFilterScope(_invoicingmonth) == false) {
      //         return false;
      //       }
      //   }
      //   return true;
      // }
      // private isManfMonthFilterPassed(_manfMonth:Date){
      //   if(this.isManfMonthFilterSelected2 == true && this.manfMonthFilter2 != null){
      //       if(this.manfMonthFilter2.isWithInFilterScope(_manfMonth) == false) {
      //         return false;
      //       }
      //   }
      //   return true;
      // }

      private isRevMonthFilterPassed(_revenueMonth:Date, _revMonSel, _revMonFiltered){
        if(_revMonSel == true && _revMonFiltered != null){
            if(_revMonFiltered.isWithInFilterScope(_revenueMonth) == false) {
              return false;
            }
        }
        return true;
      }
      private isInvMonthFilterPassed(_invoicingmonth:Date, _invMonSel, _invMonFiltered){
        if(_invMonSel == true && _invMonFiltered != null){
            if(_invMonFiltered.isWithInFilterScope(_invoicingmonth) == false) {
              return false;
            }
        }
        return true;
      }
      private isManfMonthFilterPassed(_manfMonth:Date,_manfMonSel, _manfMonFiltered){
        if(_manfMonSel == true && _manfMonFiltered != null){
            if(_manfMonFiltered.isWithInFilterScope(_manfMonth) == false) {
              return false;
            }
        }
        return true;
      }
     
      exportToExcel(){
    
        // this._dataObj1 = JSON.stringify(this.prepareDownloadObj());
    
        // setTimeout(() => {
        //   this.userImpFrm.nativeElement.submit()  
        // }, 10);
    
        console.log('exportToExcel');
      }
    
      prepareDownloadObj(){
        var _json = {};
        
        return _json;
      }
      exportasexcel(){

        //Export to excel
        let _tmpManf = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Manufacturing"));
        let a1 = JSON.parse(JSON.stringify(_tmpManf))

        let resManf = a1.map(({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }) =>
          ({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel,_typeDays }));

        let _tmpTest = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Testing"));
        let a2 = JSON.parse(JSON.stringify(_tmpTest))

        let resTest = a2.map(({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }) =>
          ({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }));

        let _tmpFAT = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under FAT"));
        let a3 = JSON.parse(JSON.stringify(_tmpFAT))

        let resFAT = a3.map(({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }) =>
          ({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }));

        let _tmpGS = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Green Sticker"));
        let a4 = JSON.parse(JSON.stringify(_tmpGS))

        let resGS = a4.map(({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }) =>
          ({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }));

        let _tmpDisp = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Dispatch"));
        let a6 = JSON.parse(JSON.stringify(_tmpDisp))

        let resDisp = a6.map(({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }) =>
          ({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }));

          
          var Heading = [
            ["Sale order", "Suborder", "Customer Name","New Sale order","Type of Equipment","Quantity of panel","Days"],
          ]; 
           
           const ws1: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resManf);//converts a DOM TABLE element to a worksheet      
           XLSX.utils.sheet_add_aoa(ws1, Heading); //heading: array of arrays

           const ws2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resTest);//converts a DOM TABLE element to a worksheet      
           XLSX.utils.sheet_add_aoa(ws2, Heading); //heading: array of arrays

           const ws3: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resFAT);//converts a DOM TABLE element to a worksheet      
           XLSX.utils.sheet_add_aoa(ws3, Heading); //heading: array of arrays

           const ws4: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resGS);//converts a DOM TABLE element to a worksheet      
           XLSX.utils.sheet_add_aoa(ws4, Heading); //heading: array of arrays

           const ws5: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resDisp);//converts a DOM TABLE element to a worksheet      
           XLSX.utils.sheet_add_aoa(ws5, Heading); //heading: array of arrays

          const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws1, 'Under Manufacturing');
         XLSX.utils.book_append_sheet(wb, ws2, 'Under Testing');
         XLSX.utils.book_append_sheet(wb, ws3, 'Under FAT');
         XLSX.utils.book_append_sheet(wb, ws4, 'Under Green Sticker');
         XLSX.utils.book_append_sheet(wb, ws5, 'Under Dispatch');
         /* save to file */
         XLSX.writeFile(wb, 'kpi_report.xlsx');
    
          
          // this.reloadData();
      }

      hyperLinkExcel(_type:number,_case:number){
        let _tmp =[];
        let _sheetName;
        switch (_type) {
          case 1: _tmp = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Manufacturing") &&
            e.daysCase == _case);
            _sheetName = 'under_manf';
            break;
          case 2: _tmp = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Testing") &&
            e.daysCase == _case);
            _sheetName = 'under_testing';
            break;
          case 3: _tmp = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under FAT") &&
            e.daysCase == _case);
            _sheetName = 'under_fat';
            break;
          case 4: _tmp = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Green Sticker") &&
            e.daysCase == _case);
            _sheetName = 'under_grnstkr';
            break;
          case 5: _tmp = this.filteredSaleOrderArray2.filter(e => e.testingCat.match("Under Dispatch") &&
            e.daysCase == _case);
            _sheetName = 'under_disptc';

            break;

        }
        
        let a = JSON.parse(JSON.stringify(_tmp))
        let resp = a.map(({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }) =>
        ({ _soNo, _ssoNo, _custName, _newSaleOrderNo, _equipTy, _qtyPanel, _typeDays }));

        
        var Heading = [
          ["Sale order", "Suborder", "Customer Name","New Sale order","Type of Equipment","Quantity of panel","Days"],
        ]; 
         
         const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(resp);//converts a DOM TABLE element to a worksheet      
         XLSX.utils.sheet_add_aoa(ws, Heading); //heading: array of arrays
         const wb: XLSX.WorkBook = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, _sheetName);
         XLSX.writeFile(wb, _sheetName+'.xlsx');

        // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
        // var wb = XLSX.utils.book_new()
        // XLSX.utils.sheet_add_json(ws,Heading,{
        //   skipHeader:true,
        //   origin:"A2"
        // });
        // XLSX.utils.sheet_add_json(ws,resp,{
        //   skipHeader:true,
        //   origin:"A3"
        // });
        // XLSX.utils.sheet_add_json(ws,
        //   [
        //     {note: "This is a note"},
        //   ],
        //   {
        //     header: ["note"],
        //     skipHeader:true,
        //     origin: "F1"
        //   }
        // );
        // XLSX.utils.book_append_sheet(wb, ws, _sheetName);
        //  XLSX.writeFile(wb, _sheetName+'.xlsx');

      }
    
     
    }
